export default "__VITE_ASSET__afc4fa17__"